import React, { useState } from "react";
import loaderImg from "./../../images/logo.png";

const Loader = (props) => {
  let { isLoading } = props;
  
  return (
    <>
    {isLoading && (
        <div className="h-[100vh] w-[100vw] bg-[rgba(0,0,0,0.5)] fixed top-0 left-0 flex flex-col z-50 justify-center items-center">
          <img
            src={loaderImg}
            alt=""
            className="mmRotate drop-shadow-xl w-[60px] h-[60px] rounded-md"
            style={{ width: "60px", height: "60px" }}
          />
        </div>
    )}
    </>
  );
};

export default Loader;
